export default __webpack_public_path__ + "static/media/people.dac82e1b.png";